export default (values) => {

  const errors = {}

  if (!values.value) errors.value = true
  
  return errors
  
}
